module.exports = __webpack_public_path__ + "media/assets/svg/logos/nosco_logo_symbol-a371f6f08e0a7301a4f8431b1ce85e20.svg";